export default {
  "fontElementMap": "i-75F",
  "container": "NnDkP",
  "fullscreen": "_0BVNP",
  "background_overlay": "r-e9v",
  "with_image": "Nc-i7",
  "options": "oc5vG",
  "webview": "_195nY",
  "grid": "H-wvj",
  "option": "eXp0r",
  "cta_button": "yuvu4",
  "add_option": "ZOFVb",
  "see_more": "SnGS3",
  "list": "o-L1T",
  "column": "HhEC7",
  "additional_note": "piwo9",
  "spinner": "XMV-H",
  "spin": "KbClx",
  "shown": "bp1Pn",
  "error": "zVkHC"
};